import React from 'react'
import { useTranslation } from 'react-i18next'
import { toTitleCase } from '../../../util/StringUtil'
import { UserLink } from '../../app/Links'
import { toLocaleString } from '../../../util/DateUtil'

export default function TreeChangesTableMetadataColumn({ treeContributionsData, contribution }) {
  const { t } = useTranslation()

  return (
    <>
      <div>
        <strong>{t('title', 'Title')}: </strong>
        <span data-testid="changeTitle">{`${toTitleCase(contribution.type)}`}</span>
      </div>
      <div>
        <strong>{t('by', 'By')}: </strong>
        <UserLink
          userId={contribution.contributorId}
          userName={
            treeContributionsData.contributorIdentities?.[contribution.contributorId]?.identity?.users?.[0]?.contactName
          }
          showId
        />
      </div>
      <div>
        <strong>{t('date', 'Date')}: </strong>
        <span data-testid="changeDate">
          {contribution.modified && toLocaleString(new Date(contribution.modified), true)}
        </span>
      </div>
    </>
  )
}
